import { cssColorValue, cssSpacing, rootStyle, semanticColors } from "../../styles/index.mjs";
import styled, { css } from "../../styled-components.mjs";
export var Help = styled.div.withConfig({
  displayName: "Help",
  componentId: "sc-1xezfve-0"
})(["", ";display:flex;margin-block-start:", ";", ""], rootStyle(), cssSpacing('tighter-2', '8px'), function (props) {
  return css(["color:", ";", ";"], props.$error ? cssColorValue(semanticColors.textNegative) : cssColorValue(semanticColors.textSubdued), props.$maxChars && css(["font-feature-settings:'tnum';justify-content:flex-end;"]));
});